<template>
  <div class="navigation-bar" v-if="!$isHideNavbar">
    <div class="navigation-bar__inner flex">
      <img
        src="../assets/imgs/icon-back.png"
        v-if="showBack"
        @click="handlePageBack"
        class="navigation-bar__back"
      />
      <span class="navigation-bar__title">{{ title }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showBack: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "加盟",
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handlePageBack() {
      this.$router.back();
    },
  },
};
</script>
<style lang="scss"  scoped>
  .navigation-bar {
    width: 100%;
    height: 88px;
    padding: 0 20px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: white;

    &__inner {
      width: 100%;
      height: 100%;
    }
    &__back {
      width: 40px;
      height: 40px;
      position: absolute;
      left: 20px;
      top: 0;
      bottom: 0;
      margin: auto;
    }

    &__title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      width: 100%;
      text-align: center;
    }
  }
</style>
